import {DocumentTypes} from "appRoot/app.constants";
import {IPouchServicePaymentOption, IServicePaymentOption} from 'shared-types/index';
import TrackingService from 'app/services/tracking/tracking.service';
import { IPouchRowItem, IPouchRows, IPouchUpdateResponse } from 'app/app.types';
import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'BookingOptionsManagerService';
class BookingOptionsManagerService {

  public getAll(): Promise<IPouchServicePaymentOption[]> {
    return new Promise((resolve) => {
      Promise.resolve(PouchLoadService.getDbLocal().allDocs({
        include_docs: true,
        attachments: false,
        startkey: DocumentTypes.MenuOption + '_',
        endkey: DocumentTypes.MenuOption + '_\uffff'
      }).then((result: unknown) => {
        let items: IPouchServicePaymentOption[] = (result as IPouchRows<IPouchServicePaymentOption>)
          .rows
          .map((item: IPouchRowItem<IPouchServicePaymentOption>) => {
            return item.doc;
          });
        items = items.sort((a: IPouchServicePaymentOption, b: IPouchServicePaymentOption) => {
          return a.name > b.name ? 1 : -1;
        });

        resolve(items);
      }));
    });
  }

  public getById(id: string): Promise<IServicePaymentOption> {
    const option: Promise<IServicePaymentOption> = PouchLoadService.getDbLocal().get(id);

    return option;
  }

  public save(item: IServicePaymentOption): Promise<PouchDB.Core.Response> {
    this.prepareForSave(item);

    // Save/Update the document
    return Promise.resolve(PouchLoadService.getDbLocal().put(item));
  }

  public bulkSave(items: IServicePaymentOption[]): Promise<IPouchUpdateResponse[]> {

    items.forEach((item: IServicePaymentOption) => {
      this.prepareForSave(item);
    });

    // Save/Update the documents
    return Promise.resolve(PouchLoadService.getDbLocal().bulkDocs(items) as unknown as IPouchUpdateResponse[]);
  }

  public remove(item: Partial<IPouchServicePaymentOption>): Promise<PouchDB.Core.Response> {
    TrackingService.trackEvent('Delete Option', {
      id: item._id,
      rev: item._rev
    });
    return Promise.resolve(PouchLoadService.getDbLocal().remove(item as PouchDB.Core.RemoveDocument));
  }

  private prepareForSave(item: Partial<IPouchServicePaymentOption>) {


    // Guard values
    item.type = DocumentTypes.MenuOption;

    // Create or Update operation, guard to _id
    if (!item._id) {
      item._id = PouchLoadService.getNewId([DocumentTypes.MenuOption]);
      TrackingService.trackEvent('New Option', {
        id: item._id
      });
    } else {
      TrackingService.trackEvent('Edit Option', {
        id: item._id
      });
    }
  }
}

const instance = new BookingOptionsManagerService();
export default instance as BookingOptionsManagerService;
